// const server = "https://marveltradeacadmy.com";
const server = "https://academymarvel.com";
export const axiosServer = "https://api.academymarvel.com";
export default server;
